import {images} from "../../assets/images";
import {shortcutService} from "../../services/shortcut.service";
import {UrlConst} from "../../utils/url.-consts";
import {useHistory} from "react-router-dom";


export const ShortcutElement: React.FC<any> = ({shortCuts, fields, fullWidth}) => {

    const history = useHistory();

    const openUrl = (item: any) => {
        shortcutService.increaseShortcutCount(item._id)
        if (item.urlType === 'FIXED') {
            window.open(item.url, "_blank")
        } else {
            let tempURL = item.url;
            const tempArray = UrlConst.slice(0, item.dynamicFields.length)
            for (let i = 0; i < tempArray.length; i++) {
                const value = fields.find((field: any) => field.organizationField._id == item.dynamicFields[i]._id)?.value
                if (value) {
                    tempURL = tempURL.replace(tempArray[i].toString(), value)
                }
            }
            if (tempURL.slice(0, 3) === 'www') {
                tempURL = 'https://' + tempURL
            }
            window.open(tempURL, "_blank")
        }
    }

    const openOrg = (item: any) => {
        history.push(`/organization-profile/${item.organization?._id}`)
    }

    return <>
        {shortCuts && shortCuts.map((item: any, index: number) => (
            <div className="up-shortcutgriditem" style={fullWidth ?  {}: {width: '41%', marginRight: 8, marginLeft: 18, marginBottom: 10}}>
                <div className="up-shortcutcontent">
                    <figure style={fullWidth ?  {} : {height: 120}}>
                        <img style={{cursor: 'pointer'}} onClick={() => openUrl(item)}
                             src={item?.icon ?? images.RestPlaceholder}
                             alt="shortcut image"/>
                        <figcaption>
                                <span>
                                    <img style={{cursor: 'pointer'}} onClick={() => openOrg(item)}
                                         src={item?.organization?.avatar ?? images.RestPlaceholder}
                                         alt="organization logo"/>
                                </span>
                        </figcaption>
                    </figure>
                </div>
                <div className="up-shortcutcardtitle">
                    <h4 style={fullWidth ?  {}: {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow:'ellipsis'}}>{item.label}</h4>
                </div>
            </div>))}
    </>

}